<template>
  <div :id="columnDeforestationChartId"></div>
</template>

<script>
import Highcharts from 'highcharts';
import ExportingData from 'highcharts/modules/export-data';
import Exporting from 'highcharts/modules/exporting';
import Accessibility from 'highcharts/modules/accessibility';

Accessibility(Highcharts);
ExportingData(Highcharts);
Exporting(Highcharts);

export default {
  props: {
    chartHeight: {
      type: Number,
      default: 400,
    },
  },
  data: () => ({
    chart: null,
  }),
  computed: {
    componentKey() {
      return `${this._uid}`;
    },
    columnDeforestationChartId() {
      return `column-deforestation-chart-${this.componentKey}`;
    },
  },
  methods: {
    async createChart(categories, series, options) {
      //if (this.chart) this.chart.destroy();
      this.chart = Highcharts.chart(this.columnDeforestationChartId, {
        chart: {
          type: 'column',
          height: this.chartHeight,
          backgroundColor: this.$vuetify.theme.themes.dark.primary.darken1,
        },
        title: {
          text: '',
        },
        exporting: {
          // allowHTML: true,
          enabled: false,
          chartOptions: {
            title: {
              // text: '<div style="fill: #fff; font-size: 16px;">' + options['exporting_title'] + '</div>',
              text: options['exporting_title'],
              style: {
                color: '#FFF',
                fontWeight: 'bold',
                fontSize: '12px',
              }
            },
          },
        },
        xAxis: {
          categories: categories,
          lineColor: '#2D324F',
          labels: {
            style: {
              color: '#8792D5',
              fontFamily: 'Roboto',
              fontStyle: 'normal',
              fontWeight: 400,
            },
          },
        },
        yAxis: {
          title: {
            text: 'Área desmatada (ha)',
            style: {
              color: '#8792D5',
              fontFamily: 'Roboto',
              fontStyle: 'normal',
              fontWeight: 400,
            },
          },
          min: 0,
          gridLineWidth: 1,
          gridLineColor: '#2D324F',
          labels: {
            style: {
              color: '#8792D5',
              fontFamily: 'Roboto',
              fontStyle: 'normal',
              fontWeight: 400,
            },
          },
        },
        tooltip: {
          valueDecimals: 2,
          valueSuffix: ' ha'
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          column: {
            borderRadius: 0,
            borderWidth: 0,
            pointPadding: 0.2,
            dataLabels: {
              color: '#8792D5',
              borderWidth: 0,
              style: {
                fontFamily: 'Roboto',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '20px',
                textOutline: 0,
              },
            },
          },
        },
        series: series,
      });
      this.chart.redraw();
    },
    exportChart(typeFile) {
      this.chart.exportChart({type: typeFile});
    },
    exportCSV() {
      this.chart.downloadCSV();
    },
    exportXLS() {
      this.chart.downloadXLS();
    },
    fullscreenChart() {
      const fullscreenControl = new Highcharts.Fullscreen(this.chart);
      fullscreenControl.open();
    },
    printChart() {
      this.chart.print();
    },
  },
};
</script>